import { Pipe, PipeTransform } from '@angular/core';

import { IndustryCatalogAssignment } from '@mp/content-manager/plattformkataloge/data-access';

@Pipe({ name: 'filterCatalogsBy' })
export class FilterCatalogsByPipe implements PipeTransform {
  transform(catalogs: IndustryCatalogAssignment[], searchTerm: string | undefined): IndustryCatalogAssignment[] {
    return catalogs.filter((catalog) => catalogMatchesSearchTerm(catalog, searchTerm));
  }
}

function catalogMatchesSearchTerm(catalog: IndustryCatalogAssignment, searchTerm: string | undefined): boolean {
  if (searchTerm === '' || searchTerm === undefined) return true;

  return [catalog.name, catalog.supplier?.name, catalog.dataSource].some(
    (field) => field?.toLowerCase().includes(searchTerm.toLowerCase()) ?? false,
  );
}
